import type { ModalAction } from "./error-catalog"

export interface ActionContext {
  closeModal: () => void
  runtimeAction?: () => void
}

/**
 * Ejecuta una `ModalAction` declarada en el catálogo.
 *
 * `callback` ejecuta la función dinámica pasada en runtime via
 * `openError({ ..., action })`. El resto son acciones declarativas que no
 * dependen del contexto del consumidor.
 *
 * Después de ejecutar la acción, cierra el modal por defecto, salvo en los
 * casos de `redirect` / `reload` donde la navegación ya descarta la UI.
 */
export function executeAction(action: ModalAction, ctx: ActionContext): void {
  switch (action.kind) {
    case "close":
      ctx.closeModal()
      return
    case "callback":
      ctx.runtimeAction?.()
      ctx.closeModal()
      return
    case "redirect":
      if (typeof window !== "undefined") {
        window.location.href = action.href
      }
      return
    case "reload":
      if (typeof window !== "undefined") {
        window.location.reload()
      }
      return
    case "tel":
      if (typeof window !== "undefined") {
        window.location.href = `tel:${action.number}`
      }
      ctx.closeModal()
      return
    case "external":
      if (typeof window !== "undefined") {
        window.open(action.href, "_blank", "noopener,noreferrer")
      }
      ctx.closeModal()
      return
  }
}
